<template>
  <div class="min-h-screen flex items-center justify-center p-4">
    <div class="w-full max-w-md p-8 space-y-6">
      <h2 class="text-3xl font-bold text-center text-gray-800">
        Create Account
      </h2>

      <form @submit.prevent="submit" class="space-y-4">
        <input
          type="text"
          placeholder="Full Name"
          v-model="form.name"
          required
          class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-yellow-300"
        />

        <input
          type="email"
          placeholder="Email"
          v-model="form.email"
          required
          class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-yellow-300"
        />

        <input
          type="password"
          placeholder="Password"
          v-model="form.password"
          required
          class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-yellow-300"
        />

        <input
          type="tel"
          placeholder="Contact (10 digits)"
          v-model="form.contact"
          required
          class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-yellow-300"
        />

        <input
          type="text"
          placeholder="City / Village"
          v-model="form.city"
          required
          class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-yellow-300"
        />

        <!-- STATE -->
        <select
          v-model="form.state"
          @change="onStateChange"
          required
          class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-yellow-300"
        >
          <option value="">Select State</option>
          <option
            v-for="state in states"
            :key="state.state"
            :value="state.state"
          >
            {{ state.state }}
          </option>
        </select>

        <!-- DISTRICT -->
        <select
          v-model="form.district"
          required
          class="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-yellow-300"
        >
          <option value="">Select District</option>
          <option
            v-for="district in districts"
            :key="district"
            :value="district"
          >
            {{ district }}
          </option>
        </select>

        <button
          type="submit"
          class="w-full bg-yellow-300 text-gray-900 font-bold py-2 rounded-md hover:bg-yellow-400 transition"
        >
          Sign Up
        </button>
      </form>

      <div class="text-center">
        <button
          @click="$emit('switch', 'login')"
          class="text-pink-500 hover:underline text-sm"
        >
          Already have an account? Login
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import stateDistricts from "@/assets/state_ditricts.json";

const emit = defineEmits(["success", "error", "switch"]);

const states = ref([]);
const districts = ref([]);

const form = ref({
  name: "",
  email: "",
  password: "",
  contact: "",
  city: "",
  state: "",
  district: "",
  profile: "user",
});

onMounted(() => {
  // load local JSON
  states.value = stateDistricts;
});

const onStateChange = () => {
  const selected = states.value.find(
    (s) => s.state === form.value.state
  );
  districts.value = selected ? selected.districts : [];
  form.value.district = "";
};

const baseUrl =
  process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";

const submit = async () => {
  try {
    const res = await fetch(`${baseUrl}/signup`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form.value),
    });

    const data = await res.json();

    if (!res.ok) {
      emit("error", data.error || "Signup failed!");
      return;
    }

    emit("success", "OTP sent!");
    sessionStorage.setItem("signupData", JSON.stringify(form.value));
    emit("switch", "otp");
  } catch {
    emit("error", "Connection error");
  }
};
</script>
